import { render, staticRenderFns } from "./FormAccessRequestDataset.vue?vue&type=template&id=0baa32b5&lang=pug"
import script from "./FormAccessRequestDataset.vue?vue&type=script&lang=js"
export * from "./FormAccessRequestDataset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0baa32b5')) {
      api.createRecord('0baa32b5', component.options)
    } else {
      api.reload('0baa32b5', component.options)
    }
    module.hot.accept("./FormAccessRequestDataset.vue?vue&type=template&id=0baa32b5&lang=pug", function () {
      api.rerender('0baa32b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/powerbi/components/FormAccessRequestDataset.vue"
export default component.exports